import React from "react";

function PlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.396"
      height="20.875"
      viewBox="0 0 17.396 20.875"
    >
      <path
        id="Path_18540"
        data-name="Path 18540"
        d="M20.917,7.74a1.74,1.74,0,0,1,3.479,0v17.4a1.74,1.74,0,0,1-3.479,0ZM7,7.74a1.74,1.74,0,1,1,3.479,0v17.4a1.74,1.74,0,0,1-3.479,0Z"
        transform="translate(-7 -6)"
        fill="#fff"
      />
    </svg>
  );
}

export default PlayIcon;
